"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Progress = function Progress(props) {
  var value = parseInt(props.progress, 10);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'progress' + (props.show ? ' is-active' : '')
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "progress__value"
  }, value, "%"), /*#__PURE__*/_react.default.createElement("div", {
    className: "progress__bar"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "progress__progress",
    style: {
      width: value + '%'
    }
  })));
};

Progress.defaultProps = {
  progress: 0,
  show: false
};
Progress.propTypes = {
  progress: _propTypes.default.number,
  show: _propTypes.default.bool
};
var _default = Progress;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/upload-modal/progress.js
// module id = 735
// module chunks = 0